import { LocalStorageKey } from 'shared/constants/localStorage'
import { User, UserWithToken } from 'shared/types/user'

export const enum CustomEvents {
  LOCAL_STORAGE_CHANGED = 'local-storage-changed',

  ONBOARDING_TOUR_COMPLETED = 'onboarding-tour-completed',
  OPEN_PRODUCT_TOUR = 'open-product-tour',
  OPEN_RELEASE_NOTES = 'open-release-notes',
  WALLPAPER_CHANGED = 'wallpaper-changed',

  AUTH_TOKEN_UPDATED = 'auth-token-updated',
  AUTH_LOGIN_REQUIRES_OTP = 'auth-login-requires-otp',
  AUTH_USER_DATA_UPDATED = 'auth-user-data-updated',

  APP_LOGGED_OUT = 'app-logged-out',

  LIVECHAT_SESSION_READY = 'livechat-session-ready',
  OPEN_LIVECHAT_USER_CHAT_MODAL = 'open-livechat-user-chat-modal',
  CLUSTER_MEET_STATE_CHANGED = 'cluster-meet-state-changed',
  SHORTCUT_ACTION_READY = 'shortcut-action-ready',
  SHORTCUT_ACTION_FAILED = 'shortcut-action-failed',

  // Ticket events
  TICKET_CREATED = 'ticket-created',
  TICKET_DELETED = 'ticket-deleted',
  OPEN_TICKET_MODAL = 'open-ticket-modal',
  OPEN_TRACK_TICKETS_MODAL = 'open-ticket-track-modal',
  TICKET_MODAL_CLOSED = 'ticket-modal-closed',

  // Task events
  OPEN_TASK_MODAL = 'open-task-modal',
  TASK_MODAL_CLOSED = 'task-modal-closed',

  // Feedback events
  OPEN_SUBMIT_REQUEST_MODAL = 'open-submit-request-modal',
  OPEN_NEW_GRANT_APPLICATION_MODAL = 'open-new-grant-application-modal'
}

interface LocalStorageChangedEvent {
  key: LocalStorageKey
}

interface AuthTokenUpdatedEvent {
  access_token: string
  refresh_token: string
  redirectRoute?: string | false
  /**
   * Present when the token was issued by a remote's own backend rather than
   * the auth service. The container adopts this user as-is and skips
   * /checkToken + /permissions — the issuing backend stays the only validator
   * of its own tokens (see useIsLoggedIn).
   */
  externalUser?: User
}

export interface AuthLoginRequiresOtpEvent {
  mobileApprovalSessionId: string | null
}

interface ShortcutActionLifecycleEvent {
  action: string
  requestId: string
}

interface AuthUserDataUpdatedEvent {
  user: UserWithToken | null
}

export interface LiveChatContact {
  name: string | null
  avatar: string | null
}

export type CustomEventsMap = {
  [CustomEvents.LOCAL_STORAGE_CHANGED]: LocalStorageChangedEvent
  [CustomEvents.AUTH_TOKEN_UPDATED]: AuthTokenUpdatedEvent
  [CustomEvents.AUTH_LOGIN_REQUIRES_OTP]: AuthLoginRequiresOtpEvent
  [CustomEvents.AUTH_USER_DATA_UPDATED]: AuthUserDataUpdatedEvent
  [CustomEvents.OPEN_LIVECHAT_USER_CHAT_MODAL]: {
    topicId: string
    requestId?: string
    contact?: LiveChatContact
  }
  [CustomEvents.CLUSTER_MEET_STATE_CHANGED]: {
    isOnline: boolean
  }
  [CustomEvents.SHORTCUT_ACTION_READY]: ShortcutActionLifecycleEvent
  [CustomEvents.SHORTCUT_ACTION_FAILED]: ShortcutActionLifecycleEvent
}
